/* eslint-disable sort-keys-fix/sort-keys-fix */
import { User } from './User';

export class Activity {
  constructor(params = {}) {
    this.id = params.id;
    this.eventDate = params.eventDate;
    this.location = params.location;
    this.action = params.action;
    this.change = params.changeData?.text;
    this.moreDetails = params.moreDetails;
    this.performer = new User(params.performer);
    this.activityObjectId = params.activityObjectId;
    this.activityObjectType = params.activityObjectType;
    this.subject = params.subject;
    this.studyEvent = params.studyEvent;
    this.studyProcedure = params.studyProcedure;
  }

  formattedDetails({ change = null, performer = null, sitesEnabled = false } = {}) {
    const details = {
      'Event Date': this.eventDate,
      'Performer': performer || this.performer?.fullNameAndEmail(),
      'Action': this.action,
      'Location': this.location?.name,
      'Object': this.activityObjectType,
      'ID': this.activityObjectId,
    };

    if (sitesEnabled) {
      details.Subject = this.subject;
      details['Study Event'] = this.studyEvent;
      details['Study Procedure'] = this.studyProcedure;
    }

    return {
      ...details,
      Details: change || this.change,
    };
  }
}
